<template>
  <input-checkbox-boolean
    v-for="language in this.languages"
    :key="language"
    v-model="this.internalData[language]"
    v-show="language === this.activeLanguage"
    :label="this.label"
    :name="`${this.name}.${language}`"
    :rules="this.rules"
    :errors="this.errors"
  />
</template>

<script>
import {I18nContext} from "@/context/I18nContext";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean";

export default {
  name: "I18nInputCheckboxBoolean",
  components: {InputCheckboxBoolean},
  extends: InputCheckboxBoolean,
  emits: ['update:data'],
  props: {
    languages: {
      type: Array,
      required: false,
      default() {
        return I18nContext.getLanguages();
      }
    },
    activeLanguage: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
      this.languages.forEach(lang => {
        if (this.internalData[lang] === undefined) {
          this.internalData.lang = false;
        }
      });
  },
  data() {
    return {
      internalData: this.data,
    };
  },
}
</script>
